__turbopack_context__.v({
  "horizontal": "Stack-module-scss-module__srOaeq__horizontal",
  "vertical": "Stack-module-scss-module__srOaeq__vertical",
});
